import React from "react";
import Header from "./Header";
import { Link } from "react-router-dom";
import Footer from "../Footer";

function Game() {
  document.title='HR School - Game'
  return (
    <div>
      <Header />
      <br />
     <div className="container">
     <center>
        <Link to="/tiktaktoe"> Tic Tac Toe</Link> <br />
        <br />
        <Link to="/plusgame"> Plus Game</Link>
        <br />
        <br />
        <Link to="/quiz">Quiz</Link>
        <br />
        <br />
        <Link to="/quiz2">World gk</Link>
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
      </center>
     </div>
      <Footer />
    </div>
  );
}

export default Game;
